import { ThemeProvider } from './contexts/ThemeProvider';
import MainPage from './pages/MainPage';
import { Routes, Route, useLocation, useNavigate, useParams } from 'react-router-dom';
import FeedbackPage from './pages/FeedbackPage';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/index';

import PaymentPage from './pages/PaymentPage';
import TipsPage from './pages/TipsPage';
import React, { useEffect } from 'react';
import DirectFeedbackPage from './pages/DirectFeedbackPage';
import DeliveryPage from './pages/DeliveryPage';
import OrderDeliveryPage from './pages/OrderDeliveryPage';
import DeliveryEndPage from './pages/DeliveryEndPage';
import NotFoundPage from './pages/NotFoundPage';
import FeedbackThanksPage from './pages/FeedbackThanksPage';



//import { persistor } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import { loadCartFromLocalStorage } from './store/slices/cartDeliverySlice';
import TestPage from './pages/TestPage';
import Platforms from './Components/Platforms';
import WebFont from 'webfontloader';
import { selectGoToFeedback } from './store/slices/branchSlice';

function ExternalRedirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

function App() {

  const getBranchLinkFromUrl = () => {
    const pathArray = window.location.pathname.split('/');
    const branchLink = pathArray[1]; // Предполагая, что link следует непосредственно за доменом
    return branchLink;
  };
  
  
  useEffect(() => {
    const loadCustomCss = async () => {
      try {
        const branchLink = getBranchLinkFromUrl();
        const response = await fetch(`${process.env.REACT_APP_URL}/custom-css/${branchLink}`);
        const css = await response.text();
        const style = document.createElement('style');
        style.innerHTML = css;
        document.head.appendChild(style);
      } catch (error) {
        console.error('Ошибка при загрузке кастомного CSS:', error);
      }
    };
  
    loadCustomCss();
  }, []);
  



  const designSettings = useSelector(selectGoToFeedback);

  useEffect(() => {
    if (designSettings && designSettings.primaryFont && designSettings.secondaryFont) {
      WebFont.load({
        google: {
          families: [designSettings.primaryFont, designSettings.secondaryFont],
          //families: ['Nunito:200,400,500,900'],
        },
        loading: function() {
          // Скрыть текст или показать загрузочный индикатор
          document.body.style.visibility = 'hidden';
        },
        active: function() {
          // Показать текст, когда шрифты загружены
          document.body.style.visibility = 'visible';
        }
      });
    }
  }, [designSettings?.primaryFont, designSettings?.secondaryFont]);
  


  return (
    <ThemeProvider>
      <Routes>
        {/* Hardcoded redirects for legacy slugs migrated to new platform */}
        <Route path="/bkbath/feedback" element={<ExternalRedirect to="https://i.restolink.ru/TCmhzCY" />} />
        <Route path="/bkhotel/feedback" element={<ExternalRedirect to="https://i.restolink.ru/WnI56Zw" />} />
        {/* Ригинал */}
        <Route path="/riginal_makh_gm3/feedback" element={<ExternalRedirect to="https://i.restolink.ru/54V8f3a" />} />
        <Route path="/riginal_makh_yar12/feedback" element={<ExternalRedirect to="https://i.restolink.ru/dH8ONSF" />} />
        <Route path="/riginal_makh_dakh35/feedback" element={<ExternalRedirect to="https://i.restolink.ru/2ar1rKD" />} />
        <Route path="/riginal_makh_mt161/feedback" element={<ExternalRedirect to="https://i.restolink.ru/klKk7T38" />} />
        <Route path="/riginal_makh_t17/feedback" element={<ExternalRedirect to="https://i.restolink.ru/ofAPMm0w" />} />
        <Route path="/riginal_makh_aa383/feedback" element={<ExternalRedirect to="https://i.restolink.ru/LuyKf6e" />} />
        <Route path="/riginal_makh_aa92b/feedback" element={<ExternalRedirect to="https://i.restolink.ru/LuyKf6e" />} />
        <Route path="/riginal_kasp_or13a/feedback" element={<ExternalRedirect to="https://i.restolink.ru/6xaJ61X" />} />
        <Route path="/riginal_buyn_ch7/feedback" element={<ExternalRedirect to="https://i.restolink.ru/KQiMPuZU" />} />
        <Route path="/riginal_derb_ag15b/feedback" element={<ExternalRedirect to="https://i.restolink.ru/5A28cXNc" />} />
        
        <Route path="/riginal_derb_sa71b/feedback" element={<ExternalRedirect to="https://i.restolink.ru/hKEsGAhV" />} />
        <Route path="/riginal_groz_gu98a/feedback" element={<ExternalRedirect to="https://i.restolink.ru/dU0hcBnZ" />} />
        <Route path="/riginal_has_gam62/feedback" element={<ExternalRedirect to="https://i.restolink.ru/7ejNkOmR" />} />
        <Route path="/riginal_kiz_t3/feedback" element={<ExternalRedirect to="https://i.restolink.ru/gEpH1jP" />} />
        <Route path="/riginalkzl1/feedback" element={<ExternalRedirect to="https://i.restolink.ru/EMYeaQ" />} />
        <Route path="/riginal-grz-orz/feedback" element={<ExternalRedirect to="https://i.restolink.ru/69J20CVn" />} />
        <Route path="/riginalnazran/feedback" element={<ExternalRedirect to="https://i.restolink.ru/gwVWjzs7" />} />
        <Route path="/riginal_groz_gu98a_man/feedback" element={<ExternalRedirect to="https://i.restolink.ru/qPnymWd" />} />




        {/* <Route path="/:branchLink/feedback/:tableId" element={<DirectFeedbackPage />} /> */}
        <Route path="/:branchLink" element={<MainPage />}></Route>
        <Route path="/:branchLink/feedback" element={<DirectFeedbackPage />}></Route>
        <Route path="/:branchLink/payment" element={<PaymentPage />}></Route>
        <Route path="/:branchLink/tips" element={<TipsPage />}></Route>
        <Route path="/:branchLink/delivery" element={<DeliveryPage />}></Route>
        <Route path="/:branchLink/orderdelivery" element={<OrderDeliveryPage />}></Route>
        <Route path="/:branchLink/deliveryend" element={<DeliveryEndPage />}></Route>
        <Route path="/notfoundpage" element={<NotFoundPage />}></Route>
        <Route path="/feedbackthanks" element={<FeedbackThanksPage />}></Route>
        <Route path="/platforms" element={<Platforms />}></Route>
        <Route path="/:branchLink/test" element={<TestPage />}></Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
